const id_rka_planning = {
    "": "perencanaan",
    add: "buat rencana",
    edit: "ubah rencana",
}

export default id_rka_planning;